export const isUserEmailExists = (email, allCoworkers) => {
  for (const coworker of allCoworkers) {
    if (coworker.requestedTo === email) {
      return true;
    }
  }
  return false;
};
